export default __webpack_public_path__ + "static/media/032-lighter.aeb9b2f6.png";